import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@mui/material';
import { LocalOffer as TagIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

/**
 * Chip de promoción reusable ("−20% PROMO"). Acento dorado (gold/gold.soft), idéntico en el
 * panel admin (preview) y en la vista del cliente. Mode-aware vía tokens del tema.
 */
function PromoChip({ discountValue, discountType = 'percentage', size = 'small', sx = {} }) {
  const { t } = useTranslation(['coupons']);
  const label = discountType === 'fixed'
    ? `-$${Number(discountValue).toLocaleString('es-CO')} ${t('promo', { ns: 'coupons', defaultValue: 'PROMO' })}`
    : `-${discountValue}% ${t('promo', { ns: 'coupons', defaultValue: 'PROMO' })}`;

  return (
    <Chip
      icon={<TagIcon sx={{ fontSize: '0.95rem !important', color: 'gold.main !important' }} />}
      label={label}
      size={size}
      sx={{
        backgroundColor: 'gold.soft',
        color: 'gold.main',
        border: '1px solid',
        borderColor: 'gold.main',
        fontWeight: 800,
        letterSpacing: '0.04em',
        ...sx
      }}
    />
  );
}

PromoChip.propTypes = {
  discountValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  discountType: PropTypes.string,
  size: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  sx: PropTypes.object
};

export default PromoChip;
